<template>
  <div class="history">
    <v-base-card>
      <template v-slot:heading>
        年度(fiscal_year) 取り込み
      </template>

      <template v-slot:content>
        <p class="mt-4 description">
          属性エクセルをアップロードすると、DB上の既存コンテンツに対して<strong>年度カラムのみ</strong>を更新します。<br>
          新規作成は行いません。属性エクセルに載っているコンテンツがDBに存在しない場合は何もしません。<br>
          問題コード + 学年 + 教科 で既存コンテンツを特定して更新します。
        </p>
        <v-alert class="mt-5 ml-auto" v-if="vdropzoneMessages.length" type="info">
          <div v-for="(msg, index) in vdropzoneMessages" :key="index">
            {{ msg }}
          </div>
        </v-alert>
        <vue-dropzone
          ref="myVueDropzone2"
          id="dropzone2"
          :options="dropzoneOptions"
          @vdropzone-success="vdropzoneSuccess"
        />
      </template>
    </v-base-card>
  </div>
</template>

<script>
import vueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import VBaseCard from '@/components/molecules/BaseCard'

export default {
  components: {
    VBaseCard,
    vueDropzone,
  },
  data () {
    return {
      dropzoneOptions: {
          url: `${this.$axios.defaults.baseURL}/api/v1/admin/contents/import_fiscal_year`,
          method: 'post',
          headers: {
            'My-Awesome-Header': 'header value',
            'access-token': this.$axios.defaults.headers.common['access-token'],
            'client': this.$axios.defaults.headers.common['client'],
            'uid': this.$axios.defaults.headers.common['uid'],
          },
          thumbnailWidth: 150,
          maxFilesize: 50,
          dictDefaultMessage:"<i class='mdi mdi-cloud-upload'></i>属性エクセルをアップする",
          timeout: 600000
      },
      vdropzoneMessages: [],
      alert_type: null
    }
  },

  methods: {
    async vdropzoneSuccess (file, response) {
      const messages = response.messages
      this.vdropzoneMessages.push(`[${messages}]${file.name}`)
    },
  }
}
</script>

<style lang="stylus" scoped>
.description
  font-size 14px
  line-height 1.8
</style>
